import React from "react";
import Box, { Props as BoxProps } from "../Box/Box";

const Container: React.FunctionComponent<BoxProps> = ({ sx, ...restProps }) => (
  <Box
    sx={{
      margin: "0 auto",
      maxWidth: ["37.5rem", null, "60rem", "75rem"],
      py: 0,
      px: "1.25rem",

      ...(sx as any),
    }}
    {...restProps}
  />
);

export default Container;
